import { TPromoCompilationType } from '../../../../types/promoSelection';
import { IProvider } from '../../../../types/promosPage/';
import { IPage } from '../../../../types/redux';
import { trackLastChanceDiscount, trackTopPromos } from '../tracking';

interface IAnalytics {
  trackAfterView: ({ page, providers }: { page: IPage; providers?: IProvider[] }) => void;
  trackClick: ({ page }: { page: IPage }) => void;
}

export function getPromoCompilationAnalytics(type: TPromoCompilationType): IAnalytics {
  switch (type) {
    case 'topPromos':
      return {
        trackAfterView({ page, providers }) {
          trackTopPromos({ action: 'show_sopr', page, providers });
        },
        trackClick({ page }) {
          trackTopPromos({ action: 'Click', page });
        },
      };
    case 'lastChanceDiscount':
      return {
        trackAfterView({ page }) {
          trackLastChanceDiscount('show_sopr', page);
        },
        trackClick({ page }) {
          trackLastChanceDiscount('Click', page);
        },
      };
    default:
      return {
        trackAfterView() {},
        trackClick() {},
      };
  }
}
